import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { compareAsc, addDays } from "date-fns";

import { DAYS_UPDATE_BANNER_INACTIVE } from "@utils/index";
import { localStorageService } from "@services/index";
import { useCommonStore } from "@stores/index";
import { XSvg } from "@components/index";
import { HelpPage } from "@pages/index";

export const UpdateBanner = () => {
  const setState = useCommonStore(({ setState }) => setState);

  const [isHidden, setIsHidden] = useState(true);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setState({ isLoading: true });
  }, [setState]);

  useEffect(() => {
    const value = localStorageService.getUpdateBannerDate();
    const lastDate = new Date(value || "");
    if (
      !value ||
      compareAsc(new Date(), addDays(lastDate, DAYS_UPDATE_BANNER_INACTIVE)) > 0
    ) {
      setIsHidden(false);
    }
    setState({ isLoading: false });
  }, [setState]);

  const onClose = () => {
    setIsHidden(true);
    localStorageService.setUpdateBannerDate();
  };

  const content = (
    <>
      We've added Private Use feature. Please click here to learn about it in
      our{" "}
      <Link to="/faq" className="font-bold underline hover:no-underline">
        FAQ
      </Link>{" "}
      section and explore{" "}
      <button
        className="font-bold underline hover:no-underline"
        onClick={() => setDrawerOpen(true)}
      >
        the tutorial
      </button>{" "}
      here.
    </>
  );

  return (
    !isHidden && (
      <>
        <div
          className="mb-4 flex h-auto flex-col justify-center gap-y-4 bg-magenta-400 px-4 py-4 text-white-100 md:mb-0 md:h-14 md:px-10 md:py-0"
          data-testid="updateBanner"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-x-4">
              <div className="shrink-0 text-300 font-bold">
                Important Update:
              </div>
              <div className="hidden font-light md:block">{content}</div>
            </div>
            <button type="button" className="ml-10" onClick={onClose}>
              <XSvg />
            </button>
          </div>
          <div className="block md:hidden">{content}</div>
        </div>
        {isDrawerOpen && (
          <HelpPage
            onClose={() => setDrawerOpen(false)}
            tutorialNames={["privateUseCreateTutorial"]}
            faqCategory={["Private Use"]}
          />
        )}
      </>
    )
  );
};
